import { useFormContext } from "react-hook-form";
import UniversityRepresentativeFormFields from "./UniversityRepresentativeFormFields";
import CompanyRepresentativeFormFields from "./CompanyRepresentativeFormFields";
import { RepresentativeType } from "../../../../../../constants/representativeType";

const RepresentativeKindFormFields = () => {
  const { getValues } = useFormContext();

  const isUniversityRepresentative = getValues().representativeType === RepresentativeType.UNIVERSITY_REPRESENTATIVE;

  return (
    <>
      {isUniversityRepresentative && <UniversityRepresentativeFormFields />}
      {!isUniversityRepresentative && <CompanyRepresentativeFormFields />}
    </>
  );
};
export default RepresentativeKindFormFields;
